import React from 'react';
import {FormFieldProps} from '../../../@types/components/Form';
import {IEmptyModel} from '../../../@interfaces/IEmptyModel';

export default function RadioListField<Model extends IEmptyModel>(props: FormFieldProps<Model>) {
    // TODO @see Fields\RadioList
    return <>RadioListField<pre>{JSON.stringify(props, null, 4)}</pre></>;
}
